import { useState, useEffect } from "react";

function useDebouncedSwitch(value: any, delay: number, condition = false) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    if (!condition) {
      setDebouncedValue(value);
      return;
    }

    const timeout = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(timeout);
    };
  }, [value, delay]);

  return debouncedValue;
}

export default useDebouncedSwitch;
